export default dateString => {
  if (dateString === '0000-00-00') return false;
  const regEx = /^\d{4}-\d{2}-\d{2}$/;
  return dateString.match(regEx) !== null;
};
